<mat-dialog-content class="mat-typography">
  <div class="consistency-container">
    <div class="toggle">
      <button
        mat-stroked-button
        [ngClass]="{
          toggle_active: consistencyChecks
        }"
        (click)="toggle()"
      >
        Consistency Checks
      </button>

      <!-- <button
        mat-stroked-button
        [ngClass]="{
          toggle_active: !consistencyChecks
        }"
        (click)="toggle()"
      >
        Data Summary
      </button> -->
    </div>
    <div class="content">
      <div *ngIf="consistencyChecks" class="consistency">
        <div class="tilte bold-normal2">Items</div>
        <div class="symobl bold-normal2">Check</div>
        <ng-container *ngFor="let check of consistencyData">
          <div class="title">
            {{ check.name }}
          </div>
          <div class="symbol">
            <div *ngIf="check.check">
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8Z"
                  fill="#8BD269"
                />
                <path
                  d="M4.44434 8.88888L7.111 10.6667L11.9999 5.33333"
                  stroke="white"
                  stroke-width="2.01011"
                />
              </svg>
            </div>
            <div *ngIf="!check.check">
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect width="16" height="16" rx="8" fill="#E61A27" />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M4.93432 4.93408C4.97678 4.89152 5.02721 4.85775 5.08274 4.83471C5.13827 4.81166 5.19779 4.7998 5.25791 4.7998C5.31803 4.7998 5.37755 4.81166 5.43308 4.83471C5.48861 4.85775 5.53904 4.89152 5.5815 4.93408L8.00017 7.35367L10.4188 4.93408C10.4613 4.89158 10.5118 4.85788 10.5673 4.83488C10.6228 4.81188 10.6823 4.80004 10.7424 4.80004C10.8025 4.80004 10.862 4.81188 10.9176 4.83488C10.9731 4.85788 11.0235 4.89158 11.066 4.93408C11.1085 4.97657 11.1422 5.02702 11.1652 5.08254C11.1882 5.13806 11.2 5.19757 11.2 5.25766C11.2 5.31776 11.1882 5.37727 11.1652 5.43279C11.1422 5.48831 11.1085 5.53876 11.066 5.58125L8.64643 7.99993L11.066 10.4186C11.1085 10.4611 11.1422 10.5115 11.1652 10.5671C11.1882 10.6226 11.2 10.6821 11.2 10.7422C11.2 10.8023 11.1882 10.8618 11.1652 10.9173C11.1422 10.9728 11.1085 11.0233 11.066 11.0658C11.0235 11.1083 10.9731 11.142 10.9176 11.165C10.862 11.188 10.8025 11.1998 10.7424 11.1998C10.6823 11.1998 10.6228 11.188 10.5673 11.165C10.5118 11.142 10.4613 11.1083 10.4188 11.0658L8.00017 8.64618L5.5815 11.0658C5.539 11.1083 5.48855 11.142 5.43303 11.165C5.37751 11.188 5.318 11.1998 5.25791 11.1998C5.19781 11.1998 5.13831 11.188 5.08278 11.165C5.02726 11.142 4.97682 11.1083 4.93432 11.0658C4.89183 11.0233 4.85812 10.9728 4.83512 10.9173C4.81212 10.8618 4.80029 10.8023 4.80029 10.7422C4.80029 10.6821 4.81212 10.6226 4.83512 10.5671C4.85812 10.5115 4.89183 10.4611 4.93432 10.4186L7.35391 7.99993L4.93432 5.58125C4.89176 5.5388 4.85799 5.48836 4.83495 5.43283C4.81191 5.37731 4.80005 5.31778 4.80005 5.25766C4.80005 5.19755 4.81191 5.13802 4.83495 5.0825C4.85799 5.02697 4.89176 4.97653 4.93432 4.93408Z"
                  fill="white"
                  stroke="white"
                  stroke-width="0.2"
                />
              </svg>
            </div>
          </div>
        </ng-container>
      </div>
      <div *ngIf="!consistencyChecks" class="data-summary">
        <div class="tilte bold-normal2">Items</div>
        <div class="value bold-normal2">Value</div>

        <div class="symobl bold-normal2">Details</div>
        <ng-container *ngFor="let check of dataSummary">
          <div class="title">
            {{ check.name }}
          </div>
          <div class="value">{{ check.value }}</div>
          <div (click)="ViewClick(check.name)" class="view bold-normal2">
            View
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button
    mat-button
    [mat-dialog-close]="true"
    [disabled]="disableNextBtn"
    (click)="next()"
    cdkFocusInitial
  >
    Next
  </button>
</mat-dialog-actions>
